module.exports = __webpack_public_path__ + "img/manda_013.8067a69b.png";